export const translations = {
  id: {
    // Header
    nav: {
      home: 'Beranda',
      about: 'Tentang Kami',
      products: 'Produk',
      services: 'Layanan',
      team: 'Tim',
      partners: 'Mitra',
      contact: 'Kontak'
    },
    
    // Hero Section
    hero: {
      badge: 'Instantly',
      title: 'Memberdayakan Pertumbuhan Bisnis Melalui Teknologi',
      subtitle: 'Solusi B2B komprehensif untuk era digital',
      button: 'Jelajahi Solusi',
      stats: {
        partners: 'Mitra Bisnis',
        solutions: 'Saluran Didukung',
        support: 'Dukungan Tersedia',
        growth: 'Potensi Pertumbuhan'
      }
    },
    
    // About Section
    about: {
      badge: 'Siapa Kami',
      title: 'Mendorong Inovasi dalam Teknologi B2B',
      mission: {
        title: 'Misi Kami',
        description: 'Memberdayakan bisnis di seluruh Indonesia dengan solusi teknologi terkini yang mengubah hubungan pelanggan dan mendorong pertumbuhan berkelanjutan.'
      },
      vision: {
        title: 'Visi Kami',
        description: 'Menjadi mitra teknologi B2B terkemuka di Indonesia, memungkinkan setiap bisnis mencapai potensi penuh mereka melalui inovasi dan keunggulan.'
      },
      platform: {
        title: 'Platform Kami',
        description: 'Instantly memberikan solusi komprehensif untuk keterlibatan pelanggan, akuisisi, layanan, dan loyalitas—semua terintegrasi dalam satu platform yang kuat.'
      }
    },
    
    // Products Section
    products: {
      badge: 'Solusi Kami',
      title: 'Platform Instantly',
      intro: 'Satu platform, kemungkinan tanpa batas. Transformasikan bisnis Anda dengan solusi komprehensif yang dirancang untuk perusahaan modern.',
      comingSoon: 'Segera Hadir',
      solutions: [
        {
          number: '01',
          title: 'Relasi Pelanggan',
          description: 'Keterlibatan multi-saluran melalui WhatsApp, Telegram, Instagram, Facebook Messenger, dan solusi chatbot cerdas.',
          tags: ['WhatsApp', 'Telegram', 'Instagram Messenger']
        },
        {
          number: '02',
          title: 'Akuisisi Pelanggan',
          description: 'Strategi periklanan berbasis data di Meta, TikTok, dan Google untuk memaksimalkan jangkauan dan ROI Anda.',
          tags: ['Meta Ads', 'TikTok Ads', 'Google Ads']
        },
        {
          number: '03',
          title: 'Layanan Pelanggan',
          description: 'Alat layanan modern termasuk Point of Sales, QR Menu, dan integrasi pembayaran yang mulus.',
          tags: ['Sistem POS', 'QR Menu', 'Pembayaran QR']
        },
        {
          number: '04',
          title: 'Loyalitas Pelanggan',
          description: 'Program loyalitas komprehensif dengan promosi, poin reward, dan strategi retensi.',
          tags: ['Promo', 'Poin Loyalitas', 'Hadiah']
        }
      ]
    },
    
    // Services Section
    services: {
      badge: 'Mengapa Memilih Kami',
      title: 'Teknologi untuk Setiap Bisnis',
      intro: 'Solusi komprehensif yang dirancang untuk berkembang bersama pertumbuhan Anda',
      benefits: [
        {
          title: 'Platform All-in-One',
          description: 'Solusi terpadu untuk semua kebutuhan keterlibatan pelanggan Anda'
        },
        {
          title: 'Analitik Real-Time',
          description: 'Wawasan berbasis data untuk mengoptimalkan strategi Anda'
        },
        {
          title: 'Aman & Andal',
          description: 'Keamanan tingkat enterprise dan uptime 99.9%'
        },
        {
          title: 'Dukungan Ahli',
          description: 'Tim khusus tersedia 24/7 untuk membantu Anda'
        }
      ]
    },
    
    // Team Section
    team: {
      badge: 'Tim Kami',
      title: 'Kepemimpinan',
      intro: 'Didorong oleh keahlian dan komitmen terhadap keunggulan',
      members: [
        {
          name: 'Yoga Bagasakthi',
          role: 'CEO',
          title: 'Chief Executive Officer'
        },
        {
          name: 'Ariandi Nugraha',
          role: 'CTO',
          title: 'Chief Technology Officer'
        },
        {
          name: 'Asad Abdullah',
          role: 'CMO',
          title: 'Chief Marketing Officer'
        }
      ]
    },

    // Partners Section
    partners: {
      badge: 'Klien & Mitra',
      title: 'Dipercaya oleh Mitra Bisnis Kami',
      intro: 'Bisnis yang tumbuh bersama platform Instantly untuk keterlibatan pelanggan melalui WhatsApp dan kanal digital lainnya.',
      list: [
        {
          name: 'Jiashen',
          category: 'Kesehatan & Wellness',
          description: 'Mitra resmi yang menggunakan platform Instantly untuk kampanye pemasaran dan layanan pelanggan melalui WhatsApp Business.'
        }
      ],
      note: 'Ingin menjadi mitra berikutnya? Hubungi kami di bawah ini.'
    },

    // Contact Section
    contact: {
      badge: 'Hubungi Kami',
      title: 'Mari Berkembang Bersama',
      intro: 'Tertarik dengan solusi kami? Hubungi tim kami dan mari diskusikan bagaimana Instantly dapat membantu bisnis Anda berkembang.',
      form: {
        firstName: 'Nama Depan',
        lastName: 'Nama Belakang',
        email: 'Email',
        phone: 'Nomor Telepon',
        businessName: 'Nama Bisnis',
        businessCategory: 'Kategori Bisnis',
        purpose: 'Tujuan / Pesan',
        placeholders: {
          firstName: 'Masukkan nama depan',
          lastName: 'Masukkan nama belakang',
          email: 'nama@email.com',
          phone: '+62 812 3456 7890',
          businessName: 'Nama perusahaan Anda',
          businessCategory: 'Pilih kategori bisnis',
          purpose: 'Ceritakan tentang kebutuhan bisnis Anda...'
        },
        categories: [
          'Pilih kategori',
          'Retail',
          'F&B (Makanan & Minuman)',
          'E-commerce',
          'Jasa',
          'Teknologi',
          'Kesehatan',
          'Pendidikan',
          'Lainnya'
        ],
        submit: 'Kirim Pesan',
        sending: 'Mengirim...',
        success: 'Pesan berhasil dikirim! Tim kami akan segera menghubungi Anda.',
        error: 'Terjadi kesalahan. Silakan coba lagi.'
      }
    },
    
    // Footer
    footer: {
      copyright: 'PT. Juara Satu Indonesia. Hak cipta dilindungi.'
    },

    // Customer Relation Detail Page
    customerRelation: {
      title: 'Relasi Pelanggan',
      subtitle: 'Keterlibatan pelanggan multi-saluran yang mengubah cara Anda berkomunikasi dengan pelanggan',
      discoverMore: 'Pelajari Lebih Lanjut',
      overview: {
        title: 'Menghubungkan Bisnis dengan Pelanggan',
        description: 'Platform Relasi Pelanggan kami memungkinkan Anda untuk terhubung dengan pelanggan melalui berbagai saluran komunikasi populer. Dari WhatsApp hingga Instagram, semua dalam satu platform terpadu yang mudah dikelola dan dioptimalkan untuk meningkatkan keterlibatan pelanggan Anda.'
      },
      channels: [
        { icon: '/whatsapp-icon.svg', name: 'WhatsApp', isImage: true },
        { icon: '/telegram-icon.svg', name: 'Telegram', isImage: true },
        { icon: '/instagram-icon.svg', name: 'Instagram', isImage: true },
        { icon: '/facebookMessenger-icon.svg', name: 'Facebook Messenger', isImage: true },
        { icon: '/mail-icon.svg', name: 'Email', isImage: true },
        { icon: '/tiktok-icon.svg', name: 'TikTok', isImage: true },
      ],
      howItWorks: {
        title: 'Cara Kerja',
        intro: 'Sistem yang sederhana namun powerful untuk mengelola semua komunikasi pelanggan Anda',
        steps: [
          {
            number: '01',
            icon: '📱',
            title: 'Akun Terdaftar Khusus',
            description: 'Daftar dan kelola akun Anda untuk setiap saluran komunikasi bisnis Anda'
          },
          {
            number: '02',
            icon: '💬',
            title: 'Kelola Percakapan',
            description: 'Terima dan balas pesan dari pelanggan melalui berbagai saluran komunikasi'
          },
          {
            number: '03',
            icon: '🤖',
            title: 'Otomasi Cerdas',
            description: 'Gunakan chatbot AI untuk merespons pertanyaan umum secara otomatis 24/7'
          },
          {
            number: '04',
            icon: '📊',
            title: 'Analisis & Insights',
            description: 'Dapatkan wawasan mendalam tentang perilaku dan preferensi pelanggan Anda'
          }
        ]
      },
      features: {
        title: 'Fitur Unggulan',
        list: [
          {
            icon: '📢',
            title: 'Manajemen Kampanye',
            description: 'Buat dan kelola kampanye untuk mencapai pelanggan target Anda'
          },
          {
            icon: '⚡',
            title: 'Balasan Cepat',
            description: 'Template pesan cepat untuk meningkatkan waktu respons SLA'
          },
          {
            icon: '👥',
            title: 'Tim Kolaborasi (CS Eskalasi)',
            description: 'Assign percakapan ke anggota tim dan bekerja bersama secara real-time, dan eskalasi ke level support yang lebih tinggi jika diperlukan'
          },
          {
            icon: '📈',
            title: 'Dashboard Analitik',
            description: 'Monitor performa tim dan tingkat kepuasan pelanggan'
          },
          {
            icon: '🔔',
            title: 'Notifikasi Real-Time',
            description: 'Dapatkan notifikasi instant untuk setiap pesan masuk'
          },
          {
            icon: '🤖',
            title: 'Pesan bot cerdas',
            description: 'Gunakan chatbot AI untuk merespons pertanyaan umum secara otomatis 24/7'
          }
        ]
      },
      benefits: {
        title: 'Manfaat untuk Bisnis Anda',
        list: [
          {
            title: 'Tingkatkan Response Time',
            description: 'Balas pesan pelanggan lebih cepat dengan sistem terpusat dan otomasi cerdas'
          },
          {
            title: 'Kurangi Biaya Operasional',
            description: 'Otomasi mengurangi beban kerja tim hingga 60% untuk pertanyaan rutin'
          },
          {
            title: 'Tingkatkan Kepuasan Pelanggan',
            description: 'Respon cepat dan personal meningkatkan customer satisfaction hingga 85%'
          },
          {
            title: 'Skalabilitas Tanpa Batas',
            description: 'Handle ribuan percakapan simultan tanpa menambah headcount'
          },
          {
            title: 'Jangkauan Pelanggan yang Lebih Luas',
            description: 'Jangkau pelanggan melalui berbagai saluran komunikasi dan perluas kesadaran merek Anda'
          },
          {
            title: 'Data-Driven Decisions',
            description: 'Ambil keputusan berdasarkan data dan insights dari interaksi pelanggan'
          }
        ]
      },
      cta: {
        title: 'Siap Meningkatkan Relasi Pelanggan Anda?',
        description: 'Hubungi tim kami untuk demo gratis dan konsultasi bagaimana platform kami dapat membantu bisnis Anda berkembang',
        button: 'Hubungi Kami Sekarang'
      }
    }
  },
  
  en: {
    // Header
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      services: 'Services',
      team: 'Team',
      partners: 'Partners',
      contact: 'Contact'
    },
    
    // Hero Section
    hero: {
      badge: 'Instantly',
      title: 'Empowering Business Growth Through Technology',
      subtitle: 'Comprehensive B2B solutions for the digital era',
      button: 'Explore Solutions',
      stats: {
        partners: 'Business Partners',
        solutions: 'Channels Supported',
        support: 'Support Available',
        growth: 'Growth Potential'
      }
    },
    
    // About Section
    about: {
      badge: 'Who We Are',
      title: 'Driving Innovation in B2B Technology',
      mission: {
        title: 'Our Mission',
        description: 'Empowering businesses across Indonesia with cutting-edge technology solutions that transform customer relationships and drive sustainable growth.'
      },
      vision: {
        title: 'Our Vision',
        description: 'To be Indonesia\'s leading B2B technology partner, enabling every business to reach their full potential through innovation and excellence.'
      },
      platform: {
        title: 'Our Platform',
        description: 'Instantly delivers comprehensive solutions for customer engagement, acquisition, service, and loyalty—all integrated in one powerful platform.'
      }
    },
    
    // Products Section
    products: {
      badge: 'Our Solutions',
      title: 'Instantly Platform',
      intro: 'One platform, infinite possibilities. Transform your business with comprehensive solutions designed for the modern enterprise.',
      comingSoon: 'Coming Soon',
      solutions: [
        {
          number: '01',
          title: 'Customer Relation',
          description: 'Multi-channel engagement through WhatsApp, Telegram, Instagram, Facebook Messenger, and intelligent chatbot solutions.',
          tags: ['WhatsApp', 'Telegram', 'Instagram Messenger']
        },
        {
          number: '02',
          title: 'Customer Acquisition',
          description: 'Data-driven advertising strategies across Meta, TikTok, and Google to maximize your reach and ROI.',
          tags: ['Meta Ads', 'TikTok Ads', 'Google Ads']
        },
        {
          number: '03',
          title: 'Customer Service',
          description: 'Modern service tools including Point of Sales, QR Menu, and seamless payment integrations.',
          tags: ['POS System', 'QR Menu', 'QR Payment']
        },
        {
          number: '04',
          title: 'Customer Loyalty',
          description: 'Comprehensive loyalty programs with promotions, reward points, and retention strategies.',
          tags: ['Promos', 'Loyalty Points', 'Rewards']
        }
      ]
    },
    
    // Services Section
    services: {
      badge: 'Why Choose Us',
      title: 'Technology for Every Business',
      intro: 'Comprehensive solutions designed to scale with your growth',
      benefits: [
        {
          title: 'All-in-One Platform',
          description: 'Unified solution for all your customer engagement needs'
        },
        {
          title: 'Real-Time Analytics',
          description: 'Data-driven insights to optimize your strategies'
        },
        {
          title: 'Secure & Reliable',
          description: 'Enterprise-grade security and 99.9% uptime'
        },
        {
          title: 'Expert Support',
          description: 'Dedicated team available 24/7 to assist you'
        }
      ]
    },
    
    // Team Section
    team: {
      badge: 'Our Team',
      title: 'Leadership',
      intro: 'Driven by expertise and commitment to excellence',
      members: [
        {
          name: 'Yoga Bagasakthi',
          role: 'CEO',
          title: 'Chief Executive Officer'
        },
        {
          name: 'Ariandi Nugraha',
          role: 'CTO',
          title: 'Chief Technology Officer'
        },
        {
          name: 'Asad Abdullah',
          role: 'CMO',
          title: 'Chief Marketing Officer'
        }
      ]
    },

    // Partners Section
    partners: {
      badge: 'Clients & Partners',
      title: 'Trusted by Our Business Partners',
      intro: 'Businesses growing with the Instantly platform for customer engagement across WhatsApp and other digital channels.',
      list: [
        {
          name: 'Jiashen',
          category: 'Health & Wellness',
          description: 'An official partner using the Instantly platform for marketing campaigns and customer service through WhatsApp Business.'
        }
      ],
      note: 'Want to be our next partner? Reach out to us below.'
    },

    // Contact Section
    contact: {
      badge: 'Contact Us',
      title: 'Let\'s Grow Together',
      intro: 'Interested in our solutions? Contact our team and let\'s discuss how Instantly can help your business grow.',
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone Number',
        businessName: 'Business Name',
        businessCategory: 'Business Category',
        purpose: 'Purpose / Message',
        placeholders: {
          firstName: 'Enter first name',
          lastName: 'Enter last name',
          email: 'name@email.com',
          phone: '+62 812 3456 7890',
          businessName: 'Your company name',
          businessCategory: 'Select business category',
          purpose: 'Tell us about your business needs...'
        },
        categories: [
          'Select category',
          'Retail',
          'F&B (Food & Beverage)',
          'E-commerce',
          'Services',
          'Technology',
          'Healthcare',
          'Education',
          'Others'
        ],
        submit: 'Send Message',
        sending: 'Sending...',
        success: 'Message sent successfully! Our team will contact you soon.',
        error: 'An error occurred. Please try again.'
      }
    },
    
    // Footer
    footer: {
      copyright: 'PT. Juara Satu Indonesia. All rights reserved.'
    },

    // Customer Relation Detail Page
    customerRelation: {
      title: 'Customer Relation',
      subtitle: 'Multi-channel customer engagement that transforms how you communicate with customers',
      discoverMore: 'Discover More',
      overview: {
        title: 'Connecting Business with Customers',
        description: 'Our Customer Relation platform enables you to connect with customers through various popular communication channels. From WhatsApp to Instagram, all in one unified platform that\'s easy to manage and optimized to enhance your customer engagement.'
      },
      channels: [
        { icon: '/whatsapp-icon.svg', name: 'WhatsApp', isImage: true },
        { icon: '/telegram-icon.svg', name: 'Telegram', isImage: true },
        { icon: '/instagram-icon.svg', name: 'Instagram', isImage: true },
        { icon: '/facebookMessenger-icon.svg', name: 'Facebook Messenger', isImage: true },
        { icon: '/mail-icon.svg', name: 'Email', isImage: true },
        { icon: '/tiktok-icon.svg', name: 'TikTok', isImage: true },
      ],
      howItWorks: {
        title: 'How It Works',
        intro: 'A simple yet powerful system to manage all your customer communications',
        steps: [
          {
            number: '01',
            icon: '📱',
            title: 'Dedicated Registred Account',
            description: 'Register and manage your own account each channel for your business'
          },
          {
            number: '02',
            icon: '💬',
            title: 'Manage Conversations',
            description: 'Receive and reply to messages from customers through various communication channels'
          },
          {
            number: '03',
            icon: '🤖',
            title: 'Smart Automation',
            description: 'Use AI chatbots to automatically respond to common questions 24/7'
          },
          {
            number: '04',
            icon: '📊',
            title: 'Analytics & Insights',
            description: 'Gain deep insights into your customers\' behavior and preferences'
          }
        ]
      },
      features: {
        title: 'Key Features',
        list: [
          {
            icon: '📢',
            title: 'Campaign Management',
            description: 'Create and manage campaigns to reach your target customers'
          },
          {
            icon: '⚡',
            title: 'Quick Replies',
            description: 'Quick message templates to improve SLA response time'
          },
          {
            icon: '👥',
            title: 'Team Collaboration (CS Escalation)',
            description: 'Assign conversations to team members and work together in real-time, and escalate to higher-level support if needed'
          },
          {
            icon: '📈',
            title: 'Analytics Dashboard',
            description: 'Monitor team performance and customer satisfaction levels'
          },
          {
            icon: '🔔',
            title: 'Real-Time Notifications',
            description: 'Get instant notifications for every incoming message'
          },
          {
            icon: '🤖',
            title: 'AI Chatbot',
            description: 'Use AI chatbots to automatically respond to common questions 24/7'
          }
        ]
      },
      benefits: {
        title: 'Benefits for Your Business',
        list: [
          {
            title: 'Improve Response Time',
            description: 'Reply to customer messages faster with centralized system and smart automation'
          },
          {
            title: 'Reduce Operational Costs',
            description: 'Automation reduces team workload by up to 60% for routine questions'
          },
          {
            title: 'Increase Customer Satisfaction',
            description: 'Fast and personal responses increase customer satisfaction up to 85%'
          },
          {
            title: 'Unlimited Scalability',
            description: 'Handle thousands of simultaneous conversations without adding headcount'
          },
          {
            title: 'Expanded Customer Reach',
            description: 'Reach customers through various communication channels and expand your brand awareness'
          },
          {
            title: 'Data-Driven Decisions',
            description: 'Make decisions based on data and insights from customer interactions'
          }
        ]
      },
      cta: {
        title: 'Ready to Enhance Your Customer Relations?',
        description: 'Contact our team for a free demo and consultation on how our platform can help your business grow',
        button: 'Contact Us Now'
      }
    }
  }
};

export const useTranslation = (language) => {
  return translations[language] || translations.id;
};
